<div id="app" class="p-mx-0 p-mx-md-3">
  <p-toolbar [style]="{'background':'white','border':'none'}">
    <div class="p-toolbar-group-left">
      <a href="https://flightbi.com"><img src="assets/logo-fligence-tsa.png" style="height:50px;" alt="Fligence TSA" /></a>
      <span class="subtitle">US Airport Traffic Monitor</span>
    </div>

    <div class="p-toolbar-group-right" style="margin-left:80px;">
      <span *ngIf="!isLoggedIn">
        <button pButton type="button" label="login" class="p-button-text p-button-lg"
                icon="pi pi-sign-in" [routerLink]="['login']"
                pTooltip="Login to see traffic by airport, terminal, date and hour as well as forecast" tooltipPosition="bottom">
        </button>
        <button pButton type="button" label="register" class="p-button-text p-button-lg"
                icon="pi pi-user-plus" [routerLink]="['register']"
                pTooltip="Register to see traffic by airport, terminal, date and hour as well as forecast" tooltipPosition="bottom">
        </button>
        <div class="badge" style="margin-left:-20px;">free</div>
      </span>
      <span *ngIf="isLoggedIn">
        <button pButton type="button" label="{{ username }}" class="p-button-text p-button-lg"
                icon="pi pi-user"  (click)="menuUser.toggle($event)"
                pTooltip="Update your profile or password" tooltipPosition="bottom">
        </button>
        <p-menu #menuUser [popup]="true" [model]="menuItemsUser"></p-menu>
        <button pButton type="button" label="logout" class="p-button-text p-button-lg"
                icon="pi pi-sign-out" (click)="logout()"
                pTooltip="Log out the system" tooltipPosition="bottom">
        </button>
      </span>
    </div>
  </p-toolbar>

  <div class="container">
    <router-outlet></router-outlet>
  </div>
</div>

<!-- Footer -->
<div style="position:relative;color:#666;margin:20px auto;width:300px;">
    Copyright ©{{copyrightYear}} <a style="text-decoration:none;color:#666;"
                       href="https://flightbi.com" target="_blank">FlightBI LLC</a>. All rights reserved.</div>

<!-- Toast -->
<p-toast key="bc" position="bottom-center"></p-toast>

<!-- Change Password Dialog -->
<p-dialog header="   " class="dialog-no-title" position="center" [(visible)]="showPasswordWin" [style]="{width: '450px'}">
    <app-password (showWindow)="closePasswordWin()"></app-password>
</p-dialog>

<!-- User Profile Dialog -->
<p-dialog header="   " class="dialog-no-title" position="center" [(visible)]="showProfileWin" [style]="{width: '500px'}">
  <app-profile (showWindow)="closeProfileWin()"></app-profile>
</p-dialog>
